const labels = document.getElementsByClassName('filter__label');

for (const label of labels) {
  label.addEventListener('click', function (element) {
    if (element.target.getAttribute('data-clear-active-filter')) return;
    if (!element.target.classList.contains("clear-filters-btn")) {
      const parent = element.target.closest('.filter');
      if (!parent) return;
      const content = parent.querySelector('.filter__content');
      if (!content) return;
      parent.classList.toggle('filter--open');
      content.classList.toggle('hidden');
    }
  });
}